module.exports = __webpack_public_path__ + "img/f-logo.e2d9b952.svg";